export default __webpack_public_path__ + "static/media/arrows-sort.3ae66989.svg";